export const interestListAmiRanges = [
  {
    interestListId: "141649f2-ccaf-4ffe-bfe3-025c69a42aef",
    amiRange: [
      {
        value: "all",
        min: "",
        max: "",
      },
      {
        value: "50",
        min: "0",
        max: "15000",
      },
      {
        value: "80",
        min: "15001",
        max: "40000",
      },
      {
        value: "120",
        min: "40001",
        max: "",
      },
    ],
  },

  {
    interestListId: "e42200c5-617d-45a8-9435-642c890c8b52",
    amiRange: [
      {
        value: "all",
        min: "",
        max: "",
      },
      {
        value: "50",
        min: "0",
        max: "70500",
      },
      {
        value: "80",
        min: "46860",
        max: "94000",
      },
      {
        value: "120",
        min: "68851",
        max: "",
      },
    ],
  },

  {
    interestListId: "3aed2ff9-d1b5-4a3a-ad0f-2273f7570704",
    amiRange: [
      {
        value: "all",
        min: "",
        max: "",
      },
      {
        value: "50",
        min: "0",
        max: "15000",
      },
      {
        value: "80",
        min: "15001",
        max: "40000",
      },
      {
        value: "120",
        min: "40001",
        max: "",
      },
    ],
  },

  {
    interestListId: "65fe95c3-53c7-472b-ae86-f4034e421e1b",
    amiRange: [
      {
        value: "all",
        min: "",
        max: "",
      },
      {
        value: "50",
        min: "0",
        max: "15000",
      },
      {
        value: "80",
        min: "15001",
        max: "40000",
      },
      {
        value: "120",
        min: "40001",
        max: "",
      },
    ],
  },

  {
    // Bella Vista
    interestListId: "0829df01-c18a-44d0-b91a-5dd26515d569",
    amiRange: [
      {
        value: "all",
        min: "",
        max: "",
      },
      {
        value: "80",
        min: "31000",
        max: "97350",
      },
      {
        value: "120",
        min: "42000",
        max: "146050",
      },
    ],
  },

  {
    // Lindley
    interestListId: "bc941cba-904a-45bf-bc95-b8df22ec73c6",
    amiRange: [
      {
        value: "all",
        min: "",
        max: "",
      },
      {
        value: "80",
        min: "31000",
        max: "97350",
      },
      {
        value: "120",
        min: "42000",
        max: "146050",
      },
    ],
  },
];
